// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"piano"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 20H22V10H2V20Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M2 4H22V10H2V4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 10V4H2V10M22 10H2M22 10V20H2V10M6 10V15M10 10V15M14 10V15M18 10V15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PianoIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'piano',
    ref,
    icon: element,
  },
));

PianoIcon.displayName = 'PianoIcon';

export default PianoIcon;
